import { updateHasLocation } from "modules/map/utils/RoutingMapUtils";

const getCoordinates = ({ latitude, longitude } = {}) => ({
  latitude: latitude ?? null,
  longitude: longitude ?? null,
});

export const getLatLngFromTripPlanLocation = (location) => {
  const coords =
    location?.coordinates?.center || location?.coordinates?.firstCenter || {};
  const latitude = coords.latitude ?? null;
  const longitude = coords.longitude ?? null;
  return {
    latitude,
    longitude,
  };
};
export const extractTripLegLocationDetails = (tripLegs) => {
  const originLocation = getCoordinates(tripLegs[0]?.origin);
  const extractedLocation = updateHasLocation(originLocation)
    ? originLocation
    : null;
  const extractedDestinations = tripLegs
    .map(({ dest }) => {
      return updateHasLocation(getCoordinates(dest))
        ? getCoordinates(dest)
        : null;
    })
    .filter((item) => item);
  if (extractedLocation && extractedDestinations) {
    return [extractedLocation, ...extractedDestinations];
  }
};
export const extractTripLegEndpoints = (tripLegs) => {
  if (!Array.isArray(tripLegs) || tripLegs.length === 0) {
    return [];
  }
  const getPosLocationLad = (loc, tripLegType) => {
    const coordinates = getLatLngFromTripPlanLocation(loc);
    if (!updateHasLocation(coordinates)) {
      return null;
    }
    return {
      location: {
        id: loc.shipperLocationId,
        name: loc.name,
        code: loc.code,
        address: loc.address,
        city: loc.city,
        state: loc.state,
        country: loc.country,
        zip: loc.zip,
        pos: {
          lat: coordinates.latitude,
          lng: coordinates.longitude,
        },
      },
      lad: {
        id: loc.lad?.id,
        name: loc.lad?.name,
        default_name: loc.lad?.canonicalName,
        code: loc.lad?.code,
        description: loc.lad?.description,
      },
      tripLegType: tripLegType,
    };
  };
  const firstOrigin = getPosLocationLad(tripLegs[0].origin, "origin");
  const lastDest = tripLegs.length
    ? getPosLocationLad(tripLegs[tripLegs.length - 1].dest, "destination")
    : null;
  return [firstOrigin, lastDest].filter(Boolean);
};

export const extractMilestoneLocationDetails = (
  milestoneCoordinates,
  milestoneCodeToBeDisplayedInMap,
) => {
  let configuratedMilestones = [];
  if (typeof milestoneCodeToBeDisplayedInMap === "string") {
    const parsed = JSON.parse(milestoneCodeToBeDisplayedInMap);
    if (Array.isArray(parsed)) {
      configuratedMilestones = parsed;
    }
  } else {
    configuratedMilestones = milestoneCodeToBeDisplayedInMap;
  }

  return milestoneCoordinates
    .filter((item) => {
      if (configuratedMilestones.length === 0) {
        return true;
      }
      return configuratedMilestones.includes(item?.statusUpdate?.code);
    })
    .map((item) => {
      const { statusUpdate } = item;
      const loc = statusUpdate?.location;
      const coordinates = loc?.coordinates?.firstCenter;

      if (!coordinates?.latitude || !coordinates?.longitude) {
        return null;
      }

      return {
        ...item,
        pos: {
          lat: coordinates.latitude,
          lng: coordinates.longitude,
        },
        location: {
          id: statusUpdate.statusLocationId,
          name: loc.name,
          code: statusUpdate.shipperLocationCode,
          address: loc.address,
          city: loc.city,
          state: loc.state,
          country: loc.country,
        },
        lad: loc?.lad,
      };
    })
    .filter(Boolean);
};
